export const getColorById = (id) => {
  switch (id) {
    case 3:
      return "#ED7D31"; // Básquetbol damas
    case 4:
      return "#009688"; // Básquetbol varones
    case 16:
      return "#FFC107"; // Vóleibol damas
    case 17:
      return "#00BCD4"; // Vóleibol varones
    case 6:
      return "#C41D0F"; // Futsal damas
    case 7:
      return "#0A599E"; // Futsal varones
    case 5:
      return "#8BC34A"; // Fútbol varones
    case 42:
      return "#BB4F94"; // Fútbol damas
    default:
      return "#8634eb"; // Color por defecto o manejo de error
  }
};
